import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/capabilities/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/capabilities/list" replace />
}
